import { useState, useEffect, useRef } from "react";
import ButtonIcon from "../ui/ButtonIcon/ButtonIcon";
import CloseBtn from "./close-btn";

import prepareAppService from "../../services/AppService";
import { ReactComponent as SvgClose } from "../../assets/window-close.svg";
import { Spinner } from "../state-indicators";

const AppCloseBtn = ({ basepath, anonymousMode, useCloseAppFile, SACR_config, loc }) => {
    const [fetching, setFetching] = useState(false);

    const appService = useRef();
    useEffect(() => {
        appService.current = prepareAppService(basepath);
    }, [basepath]);

    const onSACRCloseClick = async () => {
        setFetching(true);
        try {
            if (SACR_config?.close_url) {
                try {
                    await fetch(SACR_config.close_url, { method: "GET" });
                } catch (err) {
                    console.error(err); // eslint-disable-line
                }
            }
            window.close();
        } finally {
            setFetching(false);
        }
    };
    const onStandaloneCloseClick = async () => {
        setFetching(true);
        try {
            await appService.current?.reqCloseApp();
        } finally {
            setTimeout(() => setFetching(false), 5000);
        }
    };

    const SACR_mode = SACR_config !== undefined && SACR_config !== null;
    const AppCloseBtn = SACR_mode ? (
        <ButtonIcon onClick={onSACRCloseClick} text={loc("buttons.close")} showText={false}>
            <SvgClose />
        </ButtonIcon>
    ) : anonymousMode && useCloseAppFile ? (
        <CloseBtn loc={loc} onClick={onStandaloneCloseClick} />
    ) : null;
    return <>{fetching ? <Spinner fillParent={false} verySmall /> : AppCloseBtn}</>;
};

export default AppCloseBtn;
